import _endOfDay from 'date-fns/endOfDay';
export const endOfDay = _endOfDay;

const SEC_TO_HOURS = 60 * 60;
const SEC_TO_DAYS = SEC_TO_HOURS * 24;

/**
 * @param duration duration in sec i.e. (Date.now() - Date.now()) / 1000
 * @returns {number} duration in days
 */
export function durationToDays(duration: number): number {
    return Math.floor(duration / SEC_TO_DAYS);
}

/**
 * @returns {number} Date.now() as unix timestamp in seconds
 */
export const nowUnixTimestamp = () => Math.floor(Date.now() / 1000);

/**
 * @returns {String} current time in HH:MM:SS.sss format
 */
export const nowTimeInHHMMSSsss = () => {
    const now = new Date();
    return now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds() + '.' + now.getMilliseconds();

};

/**
 * @param duration duration in sec
 * @returns String representation of duration in format HH:MM:SS
 */
export function durationToHMS(duration: number): string {
    if (duration <= 0) {
        return '00:00:00';
    }

    duration = Math.round(duration);

    const hours = Math.floor(duration / SEC_TO_HOURS);
    const minutes = Math.floor((duration - hours * SEC_TO_HOURS) / 60);
    const seconds = duration - hours * SEC_TO_HOURS - minutes * 60;

    return `${
        hours.toString().padStart(2, '0')
    }:${
        minutes.toString().padStart(2, '0')
    }:${
        seconds.toString().padStart(2, '0')
    }`;
}

/**
 * @param duration duration in sec
 * @returns String representation of duration in format MM:SS
 */
export function durationToMS(duration: number): string {
    if (duration <= 0) {
        return '00:00';
    }

    duration = Math.round(duration);

    const hours = Math.floor(duration / SEC_TO_HOURS);
    const minutes = Math.floor((duration - hours * SEC_TO_HOURS) / 60);
    const seconds = duration - hours * SEC_TO_HOURS - minutes * 60;

    return `${
        minutes.toString().padStart(2, '0')
    }:${
        seconds.toString().padStart(2, '0')
    }`;
}
